export const INVOICE_VALUE_TO_STATUS = {
  PAID: "PAID",
  PENDING: "PENDING",
  "PAYMENT SEND": "PAYMENT SEND",
  REJECTED: "REJECTED",
  CANCEL: "CANCEL",
  APPROVED: "APPROVED",
};
